module.exports = __webpack_public_path__ + "static/media/as.e2bd63a0.png";